import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
const trimValidator: ValidatorFn = (text: FormControl) => {
  if (text.value.startsWith(' ')) {
    return {
      trimError: { value: 'text has leading whitespace' },
    };
  }
  if (text.value.endsWith(' ')) {
    return {
      trimError: { value: 'text has trailing whitespace' },
    };
  }
  return null;
};
@Component({
  selector: 'app-manage-unit',
  templateUrl: './manage-unit.component.html',
  styleUrls: ['./manage-unit.component.scss'],
})
export class ManageUnitComponent implements OnInit {
  form: FormGroup;
  submitted = false;

  unitForm: FormGroup;
  success;
  insertscheme;
  alertMessage: any;
  dataSource: any;
  selectedIndex: number;
  paginator: any;
  reg: string | RegExp;
  unitdata;
  unitdatalist = [];
  unitID;
  manageUnit: any[];
  constructor(
    private datepipe: DatePipe,
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DeleteManageUnit>
  ) {}

  ngOnInit(): void {
    this.unitForm = this.fb.group({
      unitName: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
    });

    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    let unitName = '';
    let result = unitName.trim();
    this.getManageUnit();
  }

  getUnitId(id) {
    this.unitID = id;
  }

  getManageUnit() {
    this._userService.getUnitList().subscribe((data) => {
      this.unitdata = data;
      this.unitdatalist = this.unitdata.result.data;
    });
  }

  getActiveUnitList() {
    this.spinner.show();
    var postdata = {
      removeUnitList: this.selectedItems,
    };
    this._userService.getActiveUnit(postdata).subscribe((data) => {
      this.alertMessage = data['result'];
    });
    return this.alertMessage;
  }

  addManageUnitList() {
    var manageUnitPostData = {
      unitName: this.unitForm.value.unitName,
      // "unit": this.cropForm.value.unit,
    };
   if(this.unitForm.valid){
    this._userService.addManageUnit(manageUnitPostData).subscribe((data) => {
      if (data['result'].data == 1) {
        this.toastr.success(data['result'].message, 'Success', {
          timeOut: 3000,
        });
        this.unitForm.reset();
        this.getManageUnit();
      } else {
        this.toastr.error(data['result'].message, 'Error', {
          timeOut: 3000,
        });
      }
    });
   }else{
    this.toastr.error("Please fill the unit name")
   }

    this.getManageUnit();
  }

  onSubmit() {
    if (this._userService.form.valid) {
      this._userService.insertscheme(this._userService.form.value);
      this._userService.form.reset();
      // this._userService.initializeFormGroup();
      this._userService.success('Submitted successfully');
      this.onClear();
    }
  }
  selectedItems: any = [];
  itemToDelete(unitItems, event: Event) {
    if (this.selectedItems.find((x) => x == unitItems)) {
      this.selectedItems.splice(this.selectedItems.indexOf(unitItems), 1);
    } else {
      this.selectedItems.push(unitItems);
    }
  }

  onClear() {
    this.dialogRef.close();
    // setTimeout("location.reload(true);", 500);
    this.router.navigate(['/MarketPlace']);
  }
  /*model pop up same page  */
  deleteUnit() {
    if (this.selectedItems.length > 0) {
      var postdata = {
        removeUnitList: this.selectedItems,
      };
      this._userService.getActiveUnit(postdata).subscribe((resp) => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeleteManageUnit, {
            width: '35%',
            height: '36%',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.result === 'Yes') {
              this.selectedItems.map((ele) => {
                ele.remark = result.remark;
                delete ele.unitName;
              });
              const deleteBody = {
                removeUnitList: this.selectedItems,
              };
              this._userService
                .removeManageUnit(deleteBody)
                .subscribe((data) => {
                  if (data['result'].data == 1) {
                    this.toastr.success(data['result'].message, 'Success', {
                      timeOut: 3000,
                    });
                    this.selectedItems = [];
                    this.getManageUnit();
                  }
                });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one Unit!', 'Info', {
        timeOut: 3000,
      });
    }
  }
}
/* */
@Component({
  selector: 'delete-manage-unit',
  templateUrl: 'delete-manage-unit.html',
})
export class DeleteManageUnit {
  formDelete: FormGroup;
  response;
  unitID;

  constructor(
    public dialogRef: MatDialogRef<DeleteManageUnit>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formDelete = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value: any) {
    if (this.formDelete.valid) {
      var deleteItems = {
        result: value,
        remark: this.formDelete.value.Remark,
      };

      this.dialogRef.close(deleteItems);
    } else {
      alert('Please Enter the valid remark!');
    }
  }
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }

  get f() {
    return this.formDelete.controls;
  }
}
